<template>
  <div class="app-container asset-po-page">
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="PO单号">
                <el-input
                  v-model="searchForm.opTicketid"
                  placeholder="请输入PO单号"
                  :disabled="opTicketidExact"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DCOPS单号">
                <el-input
                  v-model="searchForm.dcops_ticket_id"
                  placeholder="请输入DCOPS单号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="机房名称">
                <el-input v-model="searchForm.idc_name" placeholder="请输入机房名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务名称">
                <el-input v-model="searchForm.task_name" placeholder="请输入任务名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="是否超时">
                <el-select
                  v-model="searchForm.is_expired"
                  placeholder="请选择"
                  clearable
                  style="width: 100%"
                >
                  <el-option label="未超时" :value="0" />
                  <el-option label="已超时" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="!opTicketidExact" :span="8">
              <el-form-item label="完成时间">
                <el-date-picker
                  v-model="finishedRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="opTicketidExact ? 12 : 6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">搜索</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="openColumnsDialog">列设置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      class="po-detail-table"
    >
      <el-table-column
        v-for="column in visibleColumns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :min-width="column.minWidth"
        :align="column.align || 'left'"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="column.prop === 'assets_data'">
            <el-button
              type="text"
              size="small"
              :loading="assetsLoadingId === scope.row.id"
              @click="openAssetsDialog(scope.row)"
            >
              查看资产
            </el-button>
          </span>
          <span v-else-if="column.prop === 'is_expired'">
            <el-tag
              :type="scope.row[column.prop] === 1 ? 'danger' : scope.row[column.prop] === 0 ? 'success' : 'info'"
              size="small"
            >
              {{ scope.row[column.prop] === 1 ? '已超时' : scope.row[column.prop] === 0 ? '未超时' : '-' }}
            </el-tag>
          </span>
          <span v-else-if="column.prop === 'expire_time' || column.prop === 'finished_time'">
            {{
              scope.row[column.prop]
                ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                : '-'
            }}
          </span>
          <span v-else>{{ scope.row[column.prop] || '-' }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog title="列设置" :visible.sync="showColumnsDialog" width="400px" append-to-body>
      <el-checkbox-group v-model="selectedColumns">
        <div v-for="column in columns" :key="column.prop" style="margin-bottom: 10px">
          <el-checkbox :label="column.prop">{{ column.label }}</el-checkbox>
        </div>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showColumnsDialog = false">取消</el-button>
        <el-button @click="selectAllColumns">全选</el-button>
        <el-button @click="restoreDefaultColumns">恢复默认</el-button>
        <el-button type="primary" @click="saveColumnsDialog">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="资产数据"
      :visible.sync="assetsDialogVisible"
      width="85%"
      custom-class="json-view-dialog asset-po-json-dialog"
      append-to-body
      top="5vh"
    >
      <json-key-value-panel
        v-if="assetsDialogVisible && assetsDialogUseKv"
        :data="assetsDialogParsed"
        class="json-view-dialog-body"
      />
      <json-nested-table
        v-else-if="assetsDialogVisible"
        :data="assetsDialogContent"
        :max-height="560"
        class="json-view-dialog-body"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="assetsDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { assetConfirmAppendix, assetConfirmAppendixAssetsData } from '@/api/appManage';
import JsonKeyValuePanel from '@/components/JsonKeyValuePanel';
import JsonNestedTable from '@/components/JsonNestedTable';
import { isSingleRowKeyValueData, parseJsonValue } from '@/utils/jsonNestedTable';

export default {
  name: 'AssetBillingDetail',
  components: { JsonKeyValuePanel, JsonNestedTable },
  props: {
    opTicketid: {
      type: String,
      default: '',
    },
    opTicketidExact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchForm: {
        opTicketid: this.opTicketid || '',
        dcops_ticket_id: '',
        idc_name: '',
        task_name: '',
        is_expired: '',
      },
      finishedRange: null,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      showColumnsDialog: false,
      assetsLoadingId: null,
      assetsDialogVisible: false,
      assetsDialogContent: null,
      selectedColumns: [
        'id',
        'opTicketid',
        'po_ticket_id',
        'dcops_ticket_id',
        'bill_weight',
        'assets_data',
        'idc_name',
        'task_name',
        'is_expired',
        'finished_time',
      ],
      defaultSelectedColumns: [
        'id',
        'opTicketid',
        'po_ticket_id',
        'dcops_ticket_id',
        'bill_weight',
        'assets_data',
        'idc_name',
        'task_name',
        'is_expired',
        'finished_time',
      ],
      columns: [
        { prop: 'id', label: 'ID', minWidth: 80, align: 'center' },
        { prop: 'opTicketid', label: '鸿运侧PO工单号', minWidth: 200 },
        { prop: 'po_ticket_id', label: '腾汛侧PO工单号', minWidth: 200 },
        { prop: 'dcops_ticket_id', label: '工作工单号', minWidth: 200 },
        { prop: 'bill_weight', label: '计费权重', minWidth: 110, align: 'center' },
        { prop: 'assets_data', label: '资产数据', minWidth: 120, align: 'center' },
        { prop: 'check_memo', label: '确认信息', minWidth: 160 },
        { prop: 'check_remark', label: '备注', minWidth: 180 },
        { prop: 'expire_time', label: '超时时间', minWidth: 170 },
        { prop: 'idc_name', label: '机房名称', minWidth: 160 },
        { prop: 'ticket_instance_name', label: '流程标识', minWidth: 160 },
        { prop: 'task_name', label: '任务名称', minWidth: 160 },
        { prop: 'is_expired', label: '是否超时', minWidth: 110, align: 'center' },
        { prop: 'finished_time', label: '完成时间', minWidth: 170 },
        { prop: 'completer', label: '结单人', minWidth: 120 },
      ],
    };
  },
  computed: {
    visibleColumns() {
      return this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    },
    assetsDialogParsed() {
      return parseJsonValue(this.assetsDialogContent);
    },
    assetsDialogUseKv() {
      return isSingleRowKeyValueData(this.assetsDialogParsed);
    },
  },
  watch: {
    opTicketid: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.searchForm.opTicketid = newVal;
          this.currentPage = 1;
          this.fetchData();
        }
      },
    },
  },
  created() {
    if (!this.opTicketid) {
      this.initDefaultMonthRange();
      this.fetchData();
    }
  },
  methods: {
    initDefaultMonthRange() {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      this.finishedRange = [
        this.$moment(start).format('YYYY-MM-DD'),
        this.$moment(end).format('YYYY-MM-DD'),
      ];
    },
    buildQueryParams() {
      const params = {
        skip: this.currentPage,
        limit: this.pageSize,
        opTicketid: this.searchForm.opTicketid,
        dcops_ticket_id: this.searchForm.dcops_ticket_id,
        idc_name: this.searchForm.idc_name,
        task_name: this.searchForm.task_name,
        is_expired: this.searchForm.is_expired,
      };
      if (this.opTicketidExact) {
        params.op_ticketid_exact = 1;
        params.apply_default_month = 0;
      } else {
        params.apply_default_month = 1;
        if (this.finishedRange && this.finishedRange.length === 2) {
          params.finished_start = `${this.finishedRange[0]} 00:00:00`;
          params.finished_end = this.$moment(this.finishedRange[1])
            .add(1, 'day')
            .format('YYYY-MM-DD 00:00:00');
          params.apply_default_month = 0;
        }
      }
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      return params;
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await assetConfirmAppendix(this.buildQueryParams());
        if (response && response.data.code === 200) {
          this.tableData = response.data.data.list || [];
          this.total = response.data.data.total || 0;
        } else {
          this.$message.error(response.data?.message || '获取数据失败');
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请稍后重试');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    async openAssetsDialog(row) {
      this.assetsLoadingId = row.id;
      try {
        const res = await assetConfirmAppendixAssetsData(row.id);
        if (res.data && res.data.code === 200 && res.data.data) {
          this.assetsDialogContent = res.data.data.assets_data;
          this.assetsDialogVisible = true;
        } else {
          this.$message.warning(res.data?.message || '暂无资产数据');
        }
      } catch (e) {
        this.$message.error('加载资产数据失败');
      } finally {
        this.assetsLoadingId = null;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset() {
      this.searchForm = {
        opTicketid: this.opTicketidExact ? this.opTicketid : '',
        dcops_ticket_id: '',
        idc_name: '',
        task_name: '',
        is_expired: '',
      };
      if (!this.opTicketidExact) {
        this.initDefaultMonthRange();
      } else {
        this.finishedRange = null;
      }
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((col) => col.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
  },
};
</script>

<style scoped>
.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
.search-form {
  width: 100%;
}
.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}
.box-card {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.po-detail-table {
  width: 100% !important;
}
::v-deep .po-detail-table .el-table__header th {
  padding: 12px 0;
  font-size: 14px;
}
::v-deep .po-detail-table .el-table__body td {
  padding: 10px 0;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
::v-deep .el-select,
.el-input {
  width: 100% !important;
}
::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}
</style>
